import NotistackWrapper from "./presentation/component/NotistackWrapper";
import Router from "./presentation/routes/Router";
import {
  createTheme,
  CssBaseline,
  responsiveFontSizes,
  ThemeProvider,
} from "@mui/material";
import '@fontsource/outfit';
import { MAIN_FONT_FAMILY } from "./data/constant/Constants";

const theme = createTheme({
  typography: {
    fontFamily: MAIN_FONT_FAMILY,
  },
});

function App() {
  return (
    <ThemeProvider theme={responsiveFontSizes(theme)}>
      <CssBaseline />
      <NotistackWrapper>
        <Router />
      </NotistackWrapper>
    </ThemeProvider>
  );
}

export default App;
